import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";
import { EASE } from "../../lib/site";
import { useQuiz } from "../../hooks/QuizContext";

const AREAS = [
  "Virilha completa", "Axilas", "Buço", "Rosto completo", "Braços", "Meia perna",
  "Perna inteira", "Linha alba", "Abdômen", "Costas", "Glúteos", "Pés e mãos",
];

const Row = ({ area, i }) => {
  const { openQuiz } = useQuiz();
  const featured = i === 0;
  return (
    <li>
      <button
        type="button"
        onClick={() => openQuiz("areas_list", area)}
        className={`area-row group w-full text-left cursor-pointer ${featured ? "area-row--featured" : ""}`}
        data-testid={`area-link-${i + 1}`}
      >
        <span className="w-8 text-xs font-semibold tabular-nums opacity-70">{String(i + 1).padStart(2, "0")}</span>
        <span className="flex-1 font-display text-xl tracking-tight sm:text-2xl">{area}</span>
        <span className="hidden text-xs font-semibold tracking-[0.18em] sm:inline">{featured ? "R$ 49,90" : "CONSULTAR VALOR"}</span>
        <ArrowUpRight className="h-5 w-5 shrink-0 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
        {featured && <span className="sr-only">— oferta por R$ 49,90</span>}
      </button>
    </li>
  );
};

export const Areas = () => (
  <section id="areas" className="relative py-24 sm:py-32" aria-labelledby="areas-title" data-testid="areas-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <Eyebrow className="text-[#9A4A38]">Todas as áreas</Eyebrow>
            <h2 id="areas-title" className="section-title mt-4">Escolha a sua <span className="text-metal">área</span></h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-[#6B5650] sm:text-lg">
              No Laser Day atendemos todas as áreas do corpo. Toque na área desejada e fale direto com a gente no WhatsApp.
            </p>
          </Reveal>
          <motion.div
            className="relative mt-10 aspect-[4/3] overflow-hidden rounded-[1.75rem]"
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.2, ease: EASE }}
          >
            <img src="/img/treatment.webp" alt="Profissional realizando depilação a laser na perna de uma cliente em ambiente acolhedor" loading="lazy" className="h-full w-full object-cover" />
          </motion.div>
        </div>
      </div>
      <Reveal className="lg:col-span-7" y={50}>
        <ul className="border-t border-[#2D1C18]/15" data-testid="areas-list">
          {AREAS.map((a, i) => <Row key={a} area={a} i={i} />)}
        </ul>
      </Reveal>
    </div>
  </section>
);
